// extracted by extract-css-chunks-webpack-plugin
module.exports = {"donate":"donate-2_XCaKni"};